module.exports = __webpack_public_path__ + "static/media/ProximaNova-Black.4c25dd0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova/ProximaNova-Black.svg
// module id = 222
// module chunks = 0